// import { Box } from "@mui/material";
// import React from "react";
// import CustomDetailBox from "../../applications/summary_tabs/CustomDetailBox";
// import CustomTabButton from "../../unit/CustomTabButton";
// import LoanCurrentPayment from "./LoanCurrentPayment";
// import LoanOriginalSchedule from "./LoanOriginalSchedule";
// const LoanPaymentList = ({ ...props }) => {
//   const appId = props.appId;
//   const [activeTab, setActiveTab] = React.useState(1);

//   const handleChange = (newValue: number) => {
//     setActiveTab(newValue);
//   };
//   return (
//     <Box sx={{ width: "100%", pt: 0, height: "100%" }}>
//       <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
//         <CustomTabButton
//           id="tab-loan-current-schedule"
//           variant="text"
//           onClick={() => handleChange(1)}
//           className={activeTab === 1 ? "Mui-selected" : ""}
//         >
//           Current Schedule
//         </CustomTabButton>
//         <CustomTabButton
//           id="tab-loan-original-schedule"
//           variant="text"
//           onClick={() => handleChange(2)}
//           className={activeTab === 2 ? "Mui-selected" : ""}
//         >
//           Original Schedule
//         </CustomTabButton>
//       </Box>
//       <CustomDetailBox
//         sx={{
//           display: activeTab === 1 ? "block" : "none",
//         }}
//       >
//         <LoanCurrentPayment appId={appId} />
//       </CustomDetailBox>
//       <CustomDetailBox sx={{ display: activeTab === 2 ? "block" : "none" }}>
//         <LoanOriginalSchedule appId={appId} />
//       </CustomDetailBox>
//     </Box>
//   );
// };

// export default LoanPaymentList;

import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import { Box, IconButton } from "@mui/material";
import React from "react";
import CustomDetailBox from "../../applications/summary_tabs/CustomDetailBox";
import CustomTabButton from "../../unit/CustomTabButton";
import LoanCurrentPayment from "./LoanCurrentPayment";
import LoanOriginalSchedule from "./LoanOriginalSchedule";
const LoanPaymentList = ({ ...props }) => {
  const appId = props.appId;
  const loanNum = props?.loanNum;
  const [activeTab, setActiveTab] = React.useState(1);
  const currentPrintId = `loan-current-payment-print-${appId}`;
  const originalPrintId = `loan-original-schedule-print-${appId}`;

  const handleChange = (newValue: number) => {
    setActiveTab(newValue);
  };

  const handlePrint = () => {
    const printContainerId = activeTab === 1 ? currentPrintId : originalPrintId;
    const printNode = document.getElementById(printContainerId);

    if (!printNode) {
      return;
    }

    // const printWindow = window.open("", "_blank", "width=1200,height=800");
    const printWindow = window.open("print", "_blank", "width=1200,height=800");

    if (!printWindow) {
      return;
    }

    const styles = Array.from(
      document.querySelectorAll('link[rel="stylesheet"], style')
    )
      .map((node) => node.outerHTML)
      .join("");

    printWindow.document.open();
    printWindow.document.write(`
      <html>
        <head>
          <title>${
            activeTab === 1
              ? `Current Payment Schedule - Loan#${loanNum}`
              : `Original Payment Schedule - Loan#${loanNum}`
          }</title>
          ${styles}
          <style>
            @page {
              size: landscape;
              margin: 10mm;
            }

            html,
            body {
              width: 100%;
              height: auto;
              padding: 8px;
              font-size: 10px;
              line-height: 1.2;
              color: #111;
              overflow: visible !important;
            }

            table {
              width: 100% !important;
              table-layout: fixed;
              border-collapse: collapse;
              page-break-inside: auto;
            }

            thead {
              display: table-header-group;
            }

            tfoot {
              display: table-footer-group;
            }

            tr {
              page-break-inside: avoid;
              page-break-after: auto;
            }

            th,
            td {
               font-size: 18px !important;
              padding: 4px 6px !important;
              white-space: normal !important;
              word-break: break-word;
            }
              th svg,  td svg{
              display: none !important;
              }
              th icon,  td icon{
              display: none !important;
              }
            .hm-table-header {
              font-size: 18px !important;
              line-height: 1.15;
            }

            .amountText,
            .dateText,
            .numericText,
            p,
            a,
            span {
              font-size: 18px !important;
            }

            #${currentPrintId},
            #${originalPrintId},
            .MuiBox-root,
            .MuiTableContainer-root,
            .MuiPaper-root {
              height: auto !important;
              max-height: none !important;
              min-height: 0 !important;
              overflow: visible !important;
              box-shadow: none !important;
            }

            .MuiTableContainer-root::-webkit-scrollbar,
            .MuiBox-root::-webkit-scrollbar {
              display: none;
            }
          </style>
        </head>
        <body>
          ${printNode.outerHTML}
        </body>
      </html>
    `);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  return (
    <Box sx={{ width: "100%", pt: 0, height: "100%" }}>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box>
          <CustomTabButton
            id={`tab-loan-current-schedule-${appId}`}
            variant="text"
            onClick={() => handleChange(1)}
            className={activeTab === 1 ? "Mui-selected" : ""}
          >
            Current Schedule
          </CustomTabButton>
          <CustomTabButton
            id={`tab-loan-original-schedule-${appId}`}
            variant="text"
            onClick={() => handleChange(2)}
            className={activeTab === 2 ? "Mui-selected" : ""}
          >
            Original Schedule
          </CustomTabButton>
        </Box>
        <IconButton
          onClick={handlePrint}
          size="small"
          sx={{ mr: 1, color: "primary.main" }}
          title={
            activeTab === 1
              ? "Print Current Schedule"
              : "Print Original Schedule"
          }
          aria-label={
            activeTab === 1
              ? "Print Current Schedule"
              : "Print Original Schedule"
          }
        >
          <PrintOutlinedIcon />
        </IconButton>
      </Box>
      <CustomDetailBox
        id={currentPrintId}
        sx={{
          display: activeTab === 1 ? "block" : "none",
        }}
      >
        <LoanCurrentPayment appId={appId} />
      </CustomDetailBox>
      <CustomDetailBox
        id={originalPrintId}
        sx={{ display: activeTab === 2 ? "block" : "none" }}
      >
        <LoanOriginalSchedule appId={appId} />
      </CustomDetailBox>
    </Box>
  );
};

export default LoanPaymentList;
